(() => {
  const updateSizeSurface = (root) => {
    const selected = root.querySelector('.bb-size-picker input[type="radio"]:checked[data-bb-size-accent]');
    if (!selected) return;
    root.style.setProperty('--bb-product-accent', selected.dataset.bbSizeAccent);
    root.classList.add('bb-product-size-theme');
  };

  const updateAll = () => document.querySelectorAll('product-info').forEach(updateSizeSurface);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll, { once: true });
  } else {
    updateAll();
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches('.bb-size-picker input[type="radio"][data-bb-size-accent]')) {
      updateSizeSurface(event.target.closest('product-info'));
    }
  });
  document.addEventListener('shopify:section:load', updateAll);
})();
